import { useCallback, useState } from 'react';

import type { MouseEvent, MouseEventHandler } from 'react';

export default function useHover<T = Element>({
  onEnter,
  onLeave,
}:
  | undefined
  | {
      onEnter?: MouseEventHandler<T>;
      onLeave?: MouseEventHandler<T>;
    } = {}): {
  handlers: { onMouseEnter: MouseEventHandler<T>; onMouseLeave: MouseEventHandler<T> };
  hovered: boolean;
} {
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = useCallback(
    (event: MouseEvent<T>) => {
      setHovered(true);
      onEnter?.(event);
    },
    [onEnter],
  );

  const handleMouseLeave = useCallback(
    (event: MouseEvent<T>) => {
      setHovered(false);
      onLeave?.(event);
    },
    [onLeave],
  );

  return {
    handlers: {
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
    },
    hovered,
  };
}
